import { render } from "./ProgramFilter.vue?vue&type=template&id=2c508cfa&scoped=true"
import script from "./ProgramFilter.vue?vue&type=script&lang=js"
export * from "./ProgramFilter.vue?vue&type=script&lang=js"

import "./ProgramFilter.vue?vue&type=style&index=0&id=2c508cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c508cfa"]])

export default __exports__